module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Door-FD60/Fire-Door-FD60.svg";